import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import VidsDashboard from './VidsDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyVidsDashboard } from './companyVidsApi';

/** Company Shoorah Videos → Dashboard, scoped to this company. */
const CVidsDashboard = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyVidsDashboard(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Shoorah Videos | Shoorah</title>
      </Helmet>
      <VidsDashboard fetcher={fetcher} populationLabel={isB2BFansMode ? 'members' : 'employees'} />
    </div>
  );
};

export default CVidsDashboard;
